import { Fragment } from 'react';
import PropTypes from 'prop-types';

import Review from './Review';

const ListingReviews = ({ reviews }) => (
  <div className="listing-reviews">
    {reviews.map(review => {
      const { rating, author, text, publicationDate, id, reply } = review;
      return (
        <Fragment key={id}>
          <Review
            rating={rating}
            author={author}
            text={text}
            publicationDate={publicationDate}
          />
          {reply && (
            <Review
              text={reply.text}
              publicationDate={reply.publicationDate}
              isReply
            />
          )}
        </Fragment>
      );
    })}
  </div>
);

ListingReviews.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape(Review.propTypes))
};

ListingReviews.defaultProps = {
  reviews: {}
};

export default ListingReviews;
